/* eslint react/jsx-pascal-case: 0 */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { ACCOUNT_MENU } from 'constants/account-menu'
import NotFound from 'components/NotFound'
import NavigationContainer from 'redux/containers/components/account/NavigationContainer'

const Account = ({ view = 'details', flavour, query, option, userIs, aol }) => {
  const View = ACCOUNT_MENU[view]
  return ((!View || View.role) && !userIs(View.role))
    ? <NotFound />
    : (
      <div className='layout-width-constraint'>
        <Grid container spacing={2}>
          <Hidden mdUp>
            <Grid item xs={12} sm={12}>
              <NavigationContainer {...{ views: ACCOUNT_MENU, view, aol }} />
            </Grid>
          </Hidden>
          <Hidden smDown>
            <div className='fixed left0 pt3 pl7 pr6 h-100 shadow-black-1' style={{ width: 'inherit', maxWidth: '19rem' }}>
              <NavigationContainer {...{ views: ACCOUNT_MENU, view, aol }} />
            </div>
            <Grid item md={4} lg={3} />
          </Hidden>
          <Grid item xs={12} sm={12} md={8} lg={9}>
            <View.component
              key={view} {...{ query, flavour, option, aol }}
            />
          </Grid>
        </Grid>
      </div>
      )
}

export default Account
